<template>
  <div>
    <grid
      loading-message="Loading sent mail messages ..."
      :show-header="true"
      :list-url="listUrl"
      @item-action="onItemAction"
    />
    <teleport
      to="#vue-portal-target"
      append
    >
      <remote-modal
        ref="messageModal"
        modal-title="Message details"
        modal-class="wide-modal"
        @details-loaded="onMessageDetailsLoaded"
      >
        <template
          v-if="currentMessage"
          #modal-content
        >
          <ul>
            <li>Date: {{ currentMessage.sent_at_str }}</li>
            <li>FROM: {{ currentMessage.sent_by_str }}</li>
            <li>TO: {{ currentMessage.recipients_str }}</li>
            <li>Subject: {{ currentMessage.subject }}</li>
          </ul>
          <hr>
          <div v-html="currentMessage.body" />
          <template v-if="attachments.length > 0">
            <hr>
            <div
              v-for="attachment of attachments"
              :key="attachment.id"
            >
              <a :href="attachment.links.download">{{ attachment.filename }}</a>
            </div>
          </template>
        </template>
      </remote-modal>
    </teleport>
  </div>
</template>
<script setup lang="ts">
import {ref, computed, useTemplateRef} from 'vue'
import Grid from './grid.vue'
import RemoteModal from './remote-modal.vue'
import {Jsona, SwitchCaseJsonMapper} from 'jsona'

interface MessageAttachment {
  id: string;
  filename: string;
  links: {
    download: string;
  };
}

defineProps({
  listUrl: {default: null, type: String}
})

const currentMessage = ref<any>(null)

const messageModal = useTemplateRef("messageModal")

const attachments = computed((): MessageAttachment[] => {
  const message = currentMessage.value
  if (Array.isArray(message?.attachments)) {
    return message.attachments
  }
  return []
})

const onItemAction = (item: any, action: any): void => {
  currentMessage.value = null
  if (action.name === 'view') {
    messageModal.value?.showModal(item.links.view)
  }
}

const onMessageDetailsLoaded = (responseData: any): void => {
  currentMessage.value = new Jsona({jsonPropertiesMapper: new SwitchCaseJsonMapper()}).deserialize(responseData)
}
</script>
